import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=233dea0e&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('233dea0e')) {
      api.createRecord('233dea0e', component.options)
    } else {
      api.reload('233dea0e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=233dea0e&", function () {
      api.rerender('233dea0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/agents/Index.vue"
export default component.exports